import { useAppContext } from '@/Main';
import classNames from 'classnames';
import type { CSSProperties } from 'react';

type NewFeatureDotProps = {
  className?: string;
  style?: CSSProperties;
};

const NewFeatureDot = ({ className, style }: NewFeatureDotProps) => {
  const {
    config: { isDark }
  } = useAppContext();

  return (
    <span
      aria-label="به‌روزرسانی جدید"
      title="این ابزار به‌روزرسانی شده است"
      className={classNames('flex-shrink-0 rounded-circle', className)}
      style={{
        width: 8,
        height: 8,
        minWidth: 8,
        display: 'inline-block',
        backgroundColor: isDark
          ? 'var(--falcon-success-bg-subtle)'
          : 'var(--falcon-success)',
        ...style
      }}
    />
  );
};

export default NewFeatureDot;
